import config from '../config.json'

import { isMobileOnly } from 'react-device-detect';
import { EsquinasWidgets } from '../classes/widgetClasses';
import { getCssVariable, setCssVariable } from './styleUtils';
import { esHorizontal } from './orientationUtils';
import { CustomExpand } from '../classes/customWidgetsClasses';

const pos = { 
    margen: 10, //Margen de top, right, bottom, left y entre widgets
    tamBoton: 32,
    // iniTopLeft: 37, //Margen + 25 el alto del ícono App.js(divIcono) + 2 borde ícono
    iniTopLeft: 0,
    iniBottomRight: 16 //Alto del foot de ESRI
}

export function setPosWidget(mapView, container, { posRel, esquina, dobleLinea }, agregarAlMapa = true, posManual = []){
    //posRel: posición relativa dentro de la esquina (número desde 1)
    //esquina:
        //manual: Se debe especificar posManual, arreglo de 4 elementos ["top", 100, "left", 20]
        //topLeftDown: Arriba a la izquierda en dirección hacia abajo
        //topRightLeft: Arriba a la derecha en dirección hacia la izquierda 
        //topRightDown: Arriba a la derecha en dirección hacia abajo 
        //bottomLeftRight: Abajo a la derecha en diracción hacia la derecha
        //bottomLeftUp: Abajo a la derecha en diracción hacia arriba

    container.style.removeProperty("top");
    container.style.removeProperty("bottom");
    container.style.removeProperty("left");
    container.style.removeProperty("right");

    const { tamBoton, margen, iniTopLeft, iniBottomRight } = pos;
    const factor = (tamBoton + margen) * (posRel - 1);
    const factorMargenDobleLinea = dobleLinea ? margen * 2 + tamBoton : margen;
    if (esquina === EsquinasWidgets.posManual){
        container.style[posManual[0]] = posManual[1] + "px";
        container.style[posManual[2]] = posManual[3] + "px";
    } else if (esquina === EsquinasWidgets.topLeftDown){
        container.style.top = iniTopLeft + margen + factor + "px";
        container.style.left = factorMargenDobleLinea + "px";
    } else if (esquina === EsquinasWidgets.topRightLeft) {
        container.style.top = factorMargenDobleLinea + "px";
        container.style.right = margen + factor + "px";
    } else if (esquina === EsquinasWidgets.topRightDown){
        container.style.top = margen + factor + "px";
        container.style.right = factorMargenDobleLinea + "px"; 
    } else if (esquina === EsquinasWidgets.bottomLeftRight) {
        container.style.bottom = iniBottomRight + factorMargenDobleLinea  + "px";
        container.style.left = margen + factor + "px";
    } else if (esquina === EsquinasWidgets.bottomLeftUp) {
        container.style.bottom = iniBottomRight  + margen + factor + "px"
        container.style.left = factorMargenDobleLinea + "px"; 
    }
    if (agregarAlMapa){
        mapView.ui.add(container, "manual");
    }
}

export function closeAllItemsInLayerList(layerList){
    layerList.operationalItems.forEach(x => {
        if (x.panel){
            x.panel.open = false;
        }
    })
}

export function clickContainerExpandIfMovilVerticalAndPopupVisible(mapView, expand){
    if (mapView.popup.visible && isMobileOnly && !esHorizontal()){
        expand.container.click();
    }
}

function mostrarWidget(expand){
    expand.widget.visible = true;
    expand.containerIcono.classList.remove(expand.widget.propiedadesAdicionales.expandIconClass);
    expand.containerIcono.classList.add(expand.collapseIconClass);
}

function ocultarWidget(expand){
    expand.widget.visible = false;
    expand.containerIcono.classList.remove(expand.collapseIconClass);
    expand.containerIcono.classList.add(expand.widget.propiedadesAdicionales.expandIconClass);
}

function marcarTrueExpandsTraslapos(keyTmp, expandsTraslapos){
    expandsTraslapos.forEach(expandTraslapo => {
        expandTraslapo[keyTmp] = true;
    });
}

function setKeyOcultarPorAccion(keyTmp, expandsTraslapos){
    if (expandsTraslapos) {
        expandsTraslapos.forEach(expandTraslapo => {
            if (expandTraslapo.widget.visible){
                expandTraslapo[keyTmp] = true;
            }
        });
    }
}

export function aplicarTraslapos(popup, arrExpands, indexExpandClick = -1){
    //indexExpandClick -1 si procede de cambio de visible en popup
    //indexExpandClick -2 si no procede de ninguna acción

    const keyOcultarPorAccion = "tmpOcultarPorAccion";
    const keyOcultarPorTraslapos = "tmpOcultarPorTraslapos";
    arrExpands.forEach(expand => {
        expand[keyOcultarPorAccion] = false;
        expand[keyOcultarPorTraslapos] = false;
    });
    popup[keyOcultarPorAccion] = false;
    popup[keyOcultarPorTraslapos] = false;

    if (indexExpandClick > -2){
        if (indexExpandClick > -1){
            if (arrExpands[indexExpandClick].widget.visible){
                setKeyOcultarPorAccion(keyOcultarPorAccion, arrExpands[indexExpandClick].widget.propiedadesAdicionales.expandsTraslapos)
            }
            if (arrExpands[indexExpandClick].widget.propiedadesAdicionales.popupTraslapo){
                popup[keyOcultarPorAccion] = true;
            }
        } else {
            if (popup.visible){
                setKeyOcultarPorAccion(keyOcultarPorAccion, popup.expandsTraslapos)
            }
        }
    }

    arrExpands.forEach(expand => {
        if (expand.widget.visible && !expand[keyOcultarPorAccion]){
            if (expand.widget.propiedadesAdicionales.expandsTraslapos){
                marcarTrueExpandsTraslapos(keyOcultarPorTraslapos, expand.widget.propiedadesAdicionales.expandsTraslapos);
            }
            if (expand.widget.propiedadesAdicionales.popupTraslapo){
                popup[keyOcultarPorTraslapos] = true;
            }
        }
        if (expand.widget.propiedadesAdicionales.popupTraslapo && popup.visible && !popup[keyOcultarPorAccion]){
            expand[keyOcultarPorTraslapos] = true; //Oculta el widget
        }
    });

    if (popup[keyOcultarPorTraslapos] && popup.visible){
        setCssVariable("altoMaxPopup", "altoMaxPopupTraslapo");
    }
    if (getCssVariable("altoMaxPopup") === getCssVariable("altoMaxPopupTraslapo") && !popup[keyOcultarPorTraslapos]){
        setCssVariable("altoMaxPopup", "--altoMaxPopupNormal");
    }

    arrExpands.forEach(expand => {
        if (expand.widget.visible && expand[keyOcultarPorTraslapos]){
            ocultarWidget(expand);
        }
        if (!expand.widget.visible && expand.widgetActivo && !expand[keyOcultarPorTraslapos]){
            if (!(expand.widget.propiedadesAdicionales.popupTraslapo && popup.visible)){
                mostrarWidget(expand);
            }
        }
    });
}

export function setListenersTraslapos(popup, arrExpands){
    popup.watch("visible", () => {
        aplicarTraslapos(popup, arrExpands, -1);
    });
    for (let i = 0; i < arrExpands.length; i ++){
        arrExpands[i].container.addEventListener("click", () => {
            //En addEventListener de CustomExpand se hace visible/invisible el widget, luego se ejecuta el siguiente código:
            aplicarTraslapos(popup, arrExpands, i);
        });
    }
}

export function setWidgetAndExpand(mapView, widget, crearDiv = true, funcionSetStateNull = null){
    if (!widget.custom && crearDiv) {
        widget.container = document.createElement("div");
    }
    if (widget.visible){
        widget.container.style.display = "none"; //Se ocultan para mostrarlos al final cuando todo esté resuelto
    }
    if (widget.propiedadesAdicionales.posWidget.esquina !== EsquinasWidgets.posDiv){
        setPosWidget(mapView, widget.container, widget.propiedadesAdicionales.posWidget); //Debe ir antes del CustomExpand para obtener el top y lidiar con el BUG de visible = true
    }
    const collapseIcon = EsquinasWidgets.esquinasLeft.includes(widget.propiedadesAdicionales.posExpand.esquina) ? "esri-icon-expand" : "esri-icon-collapse";
    const customExpand = new CustomExpand(widget, collapseIcon, cambiarLabels, funcionSetStateNull);
    setPosWidget(mapView, customExpand.container, widget.propiedadesAdicionales.posExpand);
    return customExpand;
}

function cambiarLabels(labelsCambiar, iteracion = 0){
    //Le da tiempo de dibujarse para acceder al elemento del DOM y cambiar los labels

    setCssVariable("cambiarLabelColor", "cambiarLabelColorIni"); //No es necesario cambiar el cambiarLabelAnimation ya que todo está blanco
    setTimeout(() => {
        let band = false;
        for (let i = 0; i < labelsCambiar.length; i ++){ 
            const labelCambiar = labelsCambiar[i];
            const elems = document.querySelectorAll(`[${labelCambiar.atributo}="${labelCambiar.valorAtributo}"]`);
            if (elems && elems.length === 1){
                elems[0].innerHTML = labelCambiar.textoLabel;
            } else {
                band = true;
                break;
            }
        }
        if (band && iteracion < 10) {
            cambiarLabels(labelsCambiar, iteracion + 1);
        } else {
            setCssVariable("cambiarLabelColor", "cambiarLabelColorFin");
            setCssVariable("cambiarLabelAnimation", "cambiarLabelAnimationFin");
        }
    }, 100);
}

function ejecutarPatch(widget, iteracion = 0){
    setTimeout(() => {
        const band = widget.container.classList.contains("esri-widget");
        if (!band && iteracion < 10) {
            ejecutarPatch(widget, iteracion + 1);
        } else {
            widget.visible = false;
        }
    }, 100);
}

export function aplicarOcultoPorPatchVisibleAlCrear(mapView, widget){
    //Solamente aplica para widgets de esri que tengan la clase esri-widget
    widget.container = document.createElement("div");
    widget.container.style.left = 0;
    widget.container.style.top = config.topFixBugWidgetVisible;
    mapView.ui.add(widget.container, "manual");
    if (widget.viewModel.state === "ready"){
        ejecutarPatch(widget);
    } else {
        widget.viewModel.watch("state", state => {
            if (state === "ready"){
                ejecutarPatch(widget);
            }
        });
    }
}

export function setTraslapos(mapView, expands){  
    expands.layerList.widget.propiedadesAdicionales.expandsTraslapos = false;
    expands.legend.widget.propiedadesAdicionales.popupTraslapo = false;
    expands.search.widget.propiedadesAdicionales.popupTraslapo = false;
    expands.sketch.widget.propiedadesAdicionales.popupTraslapo = false;
    expands.print.widget.propiedadesAdicionales.popupTraslapo = false;
    expands.cerca.widget.propiedadesAdicionales.popupTraslapo = false;
    expands.filtro.widget.propiedadesAdicionales.popupTraslapo = false;
    expands.basemapGallery.widget.propiedadesAdicionales.popupTraslapo = false;

    expands.layerList.widget.propiedadesAdicionales.expandsTraslapos = [];
    expands.legend.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.basemapGallery,
        expands.cerca,
        expands.filtro,
        expands.print
    ];
    expands.search.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.print,
        expands.cerca,
        expands.filtro,
        expands.basemapGallery,
        expands.sketch
    ];
    expands.sketch.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.print,
        expands.cerca,
        expands.filtro,
        expands.basemapGallery,
        expands.search
    ];
    expands.print.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.cerca,
        expands.filtro,
        expands.basemapGallery,
        expands.sketch,
        expands.search,
        expands.legend
    ];
    expands.cerca.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.filtro,
        expands.print,
        expands.basemapGallery,
        expands.sketch,
        expands.search,
        expands.legend
    ];
    expands.filtro.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.cerca,
        expands.print,
        expands.basemapGallery,
        expands.sketch,
        expands.search,
        expands.legend
    ];
    expands.basemapGallery.widget.propiedadesAdicionales.expandsTraslapos = [
        expands.print,
        expands.cerca,
        expands.filtro,
        expands.sketch,
        expands.search,
        expands.legend
    ];

    mapView.popup.expandsTraslapos = [];

    if (isMobileOnly){
        expands.legend.widget.propiedadesAdicionales.expandsTraslapos.push(expands.sketch);
        expands.sketch.widget.propiedadesAdicionales.expandsTraslapos.push(expands.legend);
        if (esHorizontal()){
            expands.search.widget.propiedadesAdicionales.expandsTraslapos.push(expands.legend);
            expands.legend.widget.propiedadesAdicionales.expandsTraslapos.push(expands.search);
            expands.legend.widget.propiedadesAdicionales.expandsTraslapos.push(expands.print);
            expands.print.widget.propiedadesAdicionales.expandsTraslapos.push(expands.legend);
        } else {
            expands.layerList.widget.propiedadesAdicionales.expandsTraslapos.push(expands.basemapGallery);
            expands.layerList.widget.propiedadesAdicionales.expandsTraslapos.push(expands.print);
            expands.layerList.widget.propiedadesAdicionales.expandsTraslapos.push(expands.cerca);
            expands.layerList.widget.propiedadesAdicionales.expandsTraslapos.push(expands.filtro);
            expands.layerList.widget.propiedadesAdicionales.expandsTraslapos.push(expands.sketch);
            expands.layerList.widget.propiedadesAdicionales.expandsTraslapos.push(expands.search);
            expands.legend.widget.propiedadesAdicionales.popupTraslapo = true;
            expands.search.widget.propiedadesAdicionales.expandsTraslapos.push(expands.layerList);
            expands.sketch.widget.propiedadesAdicionales.expandsTraslapos.push(expands.layerList);
            expands.sketch.widget.propiedadesAdicionales.popupTraslapo = true;
            expands.print.widget.propiedadesAdicionales.expandsTraslapos.push(expands.layerList);
            expands.print.widget.propiedadesAdicionales.popupTraslapo = true;
            expands.cerca.widget.propiedadesAdicionales.expandsTraslapos.push(expands.layerList);
            expands.cerca.widget.propiedadesAdicionales.popupTraslapo = true;
            expands.filtro.widget.propiedadesAdicionales.expandsTraslapos.push(expands.layerList);
            expands.filtro.widget.propiedadesAdicionales.popupTraslapo = true;
            expands.basemapGallery.widget.propiedadesAdicionales.expandsTraslapos.push(expands.layerList);
            expands.basemapGallery.widget.propiedadesAdicionales.popupTraslapo = true;

            mapView.popup.expandsTraslapos.push(expands.basemapGallery);
            mapView.popup.expandsTraslapos.push(expands.sketch);
            mapView.popup.expandsTraslapos.push(expands.cerca);
            mapView.popup.expandsTraslapos.push(expands.filtro);
            mapView.popup.expandsTraslapos.push(expands.print);
            mapView.popup.expandsTraslapos.push(expands.legend);
        }
    }
}